import React from "react";
import { ReactComponent as Logo } from "../../assets/logo-stack.svg";
import OtpForm from "./OtpForm";
import BaseWrapper from "../../components/ui/BaseWrapper";
import BaseInnerWrapper from "../../components/ui/BaseInnerWrapper";
import BrandLogo from "../../assets/sidebar-nav/brand-logo.svg";

const Otp = () => {
  return (
    <BaseWrapper>
      <BaseInnerWrapper className="h-full lg:py-16 py-8  xl:mx-72 mx-0 xl:px-[70px] px-[0px]">
        <div className="lg:border border-zinc-300 rounded-lg lg:py-16 lg:px-10  flex flex-col items-center  w-[450px] mx-auto ">
          <div className=" flex flex-col justify-center items-center cursor-default w-full">
            <img src={BrandLogo} width={110} />
            <OtpForm />
          </div>
        </div>
      </BaseInnerWrapper>
    </BaseWrapper>
  );
};

export default Otp;
